import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { getStudentGoalReflection } from '../../core/dashboards';
import { getFlagByCourseId } from '../../core/features';
import useLocalStorage from '../../hooks/useLocalStorage';
import MLButton from '../MLButton/MLButton';
import styles from './StudentGoalReflectionCard.module.css';

const StudentGoalReflectionCard = ({ courseId, studentId, goal }) => {
  const [studentGoalReflection, setStudentGoalReflection] = useState(null);

  const [checkedIn, setCheckedIn] = useLocalStorage(
    `student_goal_reflection_${goal}_checkin_${courseId}`,
    false,
  );

  useEffect(() => {
    // Only fetch data if feature is enabled and studentId is available
    const flagName = `student_goal_reflection_${goal}`;
    getFlagByCourseId(courseId, flagName).then((response) => {
      if (response?.isEnabled && studentId) {
        fetchStudentGoalReflection(courseId, studentId, goal);
      }
    });
  }, [courseId, studentId, goal]);

  const fetchStudentGoalReflection = async (courseId, studentId, goal) => {
    const response = await getStudentGoalReflection(courseId, studentId, goal);
    setStudentGoalReflection(response);
  };

  const handleCheckIn = () => {
    setCheckedIn(true);
  };

  // Don't render if feature not enabled or data is not loaded yet
  if (!studentGoalReflection) {
    return null;
  }

  const iconClass = classnames(styles.icon, styles[`${goal}Icon`], {
    [styles.checkedIn]: checkedIn,
  });

  return (
    <div
      className={classnames(styles.cardContainer, {
        [styles.checkedIn]: checkedIn,
      })}
    >
      <div className={iconClass} aria-hidden="true" />
      <div className={styles.textContent}>
        <div
          className={styles.title}
          data-test-id="student_gb_goal_reflection_header"
        >
          Goal Reflection
        </div>
        <div className={styles.response}>
          "{studentGoalReflection.surveyResponse}"
        </div>
        <div className={styles.question}>
          {studentGoalReflection.surveyQuestionText}
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <MLButton
          btnType="secondary"
          className={classnames(styles.button, {
            [styles.checkedIn]: checkedIn,
          })}
          testId={`student_gb_goal_reflection_checkin_btn_${goal}`}
          onClick={handleCheckIn}
          disabled={checkedIn}
        >
          Time to Check In!
        </MLButton>
      </div>
    </div>
  );
};

export default StudentGoalReflectionCard;
